module.exports = __webpack_public_path__ + "static/media/TrelloSocial.b9707fac.png";